import React, { Fragment } from 'react'
import Flag from '../Flag'
import { COUNTRIES } from '../../utils/countries'

import IconButton from '@mui/material/IconButton'
import Styled from './styled'

function getCallingCodeOfCountry(isoCode) {
  return COUNTRIES[isoCode]?.[0]
}

function FlagButton({
  disableDropdown = false,
  forceCallingCode = false,
  flagSize = 'small',
  isFlagsMenuOpened = false,
  isoCode,
  ...iconButtonProps
}) {
  return (
    <Fragment>
      <IconButton
        {...iconButtonProps}
        aria-label="Select country"
        className="MuiTelInput-IconButton"
        aria-haspopup="listbox"
        sx={{ aspectRatio: '1 / 1' }}
        aria-controls={isFlagsMenuOpened ? 'select-country' : undefined}
        aria-expanded={isFlagsMenuOpened ? 'true' : 'false'}
      >
        <Flag size={flagSize} isoCode={isoCode} />
      </IconButton>
      <Styled.CallingCodeSplitted>+{getCallingCodeOfCountry(isoCode)}</Styled.CallingCodeSplitted>
    </Fragment>
  )
}

export default FlagButton
